export default __webpack_public_path__ + "6543b8864423b7cb64775a1bc94b80a6.woff2";